<template>
  <div class="tutorSendMail-list">
    <div class="list-table__title">Tutor List</div>
    <b-table
      striped
      hover
      fixed
      Outlined
      show-empty
      selectable
      :empty-text="'No data available'"
      :items="tutors"
      :fields="fields"
      :table-class="'list-table text-center'"
      :thead-class="'list-table__head'"
      :tbody-class="'list-table__body'"
    >
      <template #cell(Selected)="{ rowSelected }">
        <template v-if="rowSelected">
          <span aria-hidden="true">&check;</span>
          <span class="sr-only">Selected</span>
        </template>
        <template v-else>
          <span aria-hidden="true">&nbsp;</span>
          <span class="sr-only">Not selected</span>
        </template>
      </template>
    </b-table>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'
import { Moment } from 'moment';
import { Position } from '@/store/master/types';
import { Tutor } from '@/store/tutors/types';

export default Vue.extend({
  data() {
    return {
      selectMode: 'multi',
      fields: [
        { key: 'Selected' },
        {
          key: 'id',
          label: 'Tutor ID',
          sortable: true,
        },
        {
          key: 'name',
          label: 'Tutor Name',
        },
        {
          key: 'position',
          label: 'Position',
          formatter: (position: Position) => position.name,
        },
        {
          key: 'hireDate',
          label: 'Hire Date',
          formatter: (hireDate: Moment|undefined) => hireDate && hireDate.format('YYYY/MM/DD'),
        },
        {
          key: 'phone1',
          label: 'Phone',
        },
        {
          key: 'email1',
          label: 'Email',
        },
        {
          key: 'nationality.code',
          label: 'Nearest station',
        },
      ],
    };
  },

  props: {
    tutors: Array as PropType<Tutor[]>,
  },
})
</script>

<style>
.tutorSendMail-list .list-table .list-table__head {
  font-size: .5rem;
}

.tutorSendMail-list .list-table .list-table__body td {
  font-size: .5rem;
  padding: 1rem;
}
</style>

<style scoped>
  .detail-button {
    display: block;
    text-decoration: none;
    color: #000;
    padding: 10px;
    border: 2px solid #AAAFB6;
    border-radius: 20px;
    cursor: pointer;
  };

  .detail-button:hover {
    background: #000;
  };
</style>
